// extracted by mini-css-extract-plugin
module.exports = {"ModalBody":"EditModal__ModalBody___1Ht1m"};